import Home from "../pages/home";
import Dashboard from "../pages/client/dashboard";
import Signup from "../pages/auth/signup";
import Login from "../pages/auth/login";
import ForgotPassword from "../pages/auth/forgot";
import ResetPassword from "../pages/auth/reset";
import VerifyAccount from "../pages/auth/verify";
import AdminDashboard from "../pages/admin/dashboard";
import Profile from "../pages/client/profile";
import Password from "../pages/client/password";
import AdminQuiz from "../pages/admin/quiz";
import AdminQuizAdd from "../pages/admin/quiz/add";

export const ROUTES = [
  {
    path: "/",
    component: Home,
  },
];

export const AUTH_ROUTES = [
  {
    path: "/auth/signin",
    component: Login,
  },
  {
    path: "/auth/signup",
    component: Signup,
  },
  {
    path: "/auth/forgot",
    component: ForgotPassword,
  },
  {
    path: "/auth/reset/:token",
    component: ResetPassword,
  },
  {
    path: "/auth/verify/:token",
    component: VerifyAccount,
  },
];

export const CLIENT_ROUTES = [
  {
    path: "/dashboard",
    component: Dashboard,
  },
];

export const ADMIN_ROUTES = [
  {
    path: "/admin/dashboard",
    component: AdminDashboard,
  },
  {
    path: "/admin/dashboard/quizes",
    component: AdminQuiz,
  },
  {
    path: "/admin/dashboard/quiz/:id",
    component: AdminQuizAdd,
  },
  {
    path: "/admin/dashboard/profile",
    component: Profile,
  },
  {
    path: "/admin/dashboard/password",
    component: Password,
  },
];
